module.exports = __webpack_public_path__ + "static/media/muffito_logo.033de794.png";